<div class="bg-th-blue mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center h-35">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>
    </div>
</div>
<div id="test" class="fixed-map3">
    <div class="position-absolute" id="map_tooltip" data-bs-html="true">
    </div>

    <div class="icon-Map position-absolute index d-flex flex-column ">

        <img src="../../../assets/Img/layer-icon.png" title="تغییر نوع نقشه" (click)="changeTail()"  class="bg-third p-2 circel-2 my-1 text-center pointer text-white icon-Img">

    </div>
</div>